export default "__VITE_ASSET__DrQJKr8m__"